export const tableStyling = {
    paperTable: {
        '& .default-cell': {
            background: '#bbbbbb',
            color: 'white',
            '&.positive': { background: 'green' },
            '&.negative': { background: 'red' },
        },
    },
} as const;

export default tableStyling;
